(function (angular) {
    angular.module('bizPartEngage').service('modules.goals.calendar.service', calendarService);

    calendarService.$inject = ["$http"];

    function calendarService($http) {


    }

})(window.angular);